export default __webpack_public_path__ + "media/images/1-6f8984ecebbe581e43f4f78f27451eb7.mp4";